// Shared semantics for the "Title defaults to the Name field" behavior, used by
// both the save/serialization layer (BasePersistor) and the metadata UI, so the
// displayed Title and the persisted Title always agree.

// True when the value still holds a localized "auto-set" placeholder. The
// placeholder is a UI marker and must never be treated as real Title data.
export const titleMatchesPlaceholder = (value: any, placeholderVariants: string[]): boolean =>
  typeof value === "string" && placeholderVariants.some(variant => variant === value.trim());

// True when the user has supplied no meaningful Title (null/undefined/blank).
export const titleIsEmpty = (value: any): boolean =>
  value === null || value === undefined || (typeof value === "string" && value.trim().length === 0);

// True when the Title carries no explicit user value and should default to the
// Name field (either empty/blank or still holding the auto-set placeholder).
export const titleIsUnset = (value: any, placeholderVariants: string[]): boolean =>
  titleIsEmpty(value) || titleMatchesPlaceholder(value, placeholderVariants);
